import { useCallback, useEffect, useMemo } from 'react';

import H from '@zola/zola-ui/src/typography/Headings';

import { VendorCardVendor } from '~/components/common/cards/util/types';
import { VendorCardProps } from '~/components/common/cards/VendorCard/VendorCard';
import { doTrackStorefrontListViewed } from '~/contexts/TrackingContracts/trackingContractsHelpers';
import { TrackingProductLocation } from '~/util/trackingHelper';

import { NotNullMembersBriefLocation } from '../../../util/types';
import {
  getRecentlyViewedVendorCardProps,
  useRecentlyViewedStorefronts,
} from '../contexts/RecentlyViewedStorefrontsContext';
import Shelf from './Shelf';
import SideScrollingCardList from './SideScrollingCardList';

import styles from '../personalizedContent.module.less';

const RecentlyViewed = ({ briefLocation }: { briefLocation: NotNullMembersBriefLocation }) => {
  const { recentlyViewed } = useRecentlyViewedStorefronts();

  const queriedLocation = useMemo(() => {
    return `${briefLocation.name}, ${briefLocation.stateCode}`;
  }, [briefLocation]);

  const getCardProps = useCallback(
    (vendor: VendorCardVendor): Partial<VendorCardProps> => {
      return {
        showDetails: true,
        showHomeService: true,
        trackClick: true,
        listingShelfName: 'RECENTLY_VIEWED',
        ...getRecentlyViewedVendorCardProps(vendor, queriedLocation),
      };
    },
    [queriedLocation]
  );

  useEffect(() => {
    if (recentlyViewed.length > 0) {
      doTrackStorefrontListViewed({
        storefrontList: recentlyViewed,
        listingShelfName: 'RECENTLY_VIEWED',
      });
    }
  }, [recentlyViewed]);

  return (
    <>
      {recentlyViewed && recentlyViewed.length > 0 && (
        <Shelf>
          <div className={styles.shelfHed}>
            <div>
              <H.Title2 presentation="h3">
                <span className={styles.serif}>Recently viewed</span>
              </H.Title2>
            </div>
          </div>
          <SideScrollingCardList
            cardList={recentlyViewed}
            getCardProps={getCardProps}
            trackingProductLocation={TrackingProductLocation.RECENTLY_VIEWED_VENDORS}
          />
        </Shelf>
      )}
    </>
  );
};

export default RecentlyViewed;
